// ----------------------------------------------------------------------

export default function TableCell(theme) {
    return {
        MuiTableCell: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-input.MuiOutlinedInput-input': {
                        padding: '10px 0px 8px 0px',
                        textAlign: 'center',
                    },
                },
                head: {
                    fontWeight: theme.typography.fontWeightRegular,
                    '& .MuiTableSortLabel-root': {
                        fontWeight: theme.typography.fontWeightRegular,
                    },
                    '& .MuiTableSortLabel-root.Mui-active': {
                        color: theme.palette.text.primary,
                        fontWeight: theme.typography.fontWeightBold,
                    },
                    '& .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon': {
                        color: theme.palette.text.primary,
                        fontWeight: theme.typography.fontWeightBold,
                    },
                },
            },
        },
    };
}
